module.exports = __webpack_public_path__ + "img/home-deposit.59d0371f.svg";